<script setup lang="ts">
import NavigationWrapper from "../components/navigation/NavigationWrapper.vue";
import Header from "../components/header/Header.vue";
import { useBaseStore } from "@/stores/base";
const store = useBaseStore();
import { computed, onBeforeMount, onMounted } from "vue";
import { toastApiResult } from "@/toaster";
import { useApiClient } from "@/api/client";
import ReloadPrompt from "@/ui/components/ReloadPrompt.vue";
import Dialog from "@/ui/components/dialog.vue";
import Toast from "@/ui/components/toast.vue";
import { useRoute } from "vue-router";
import InvalidPermissions from "@/ui/components/invalidPermissions.vue";
const route = useRoute();

onBeforeMount(() => {
	if (typeof localStorage.getItem("APP_THEME") === "string") {
		//@ts-ignore
		store.SET_APP_THEME(localStorage.getItem("APP_THEME"));
	}
});

const showSnackbar = computed(() => {
	return store.toaster !== null;
});

const requiresAuth = computed(() => {
	return route?.meta?.requiresAuth ?? true;
});
</script>

<template>
	<v-app>
		<invalid-permissions
			v-if="useBaseStore().showInvalidPermissions?.status === 403"
		/>
		<Dialog />
		<Toast />
		<v-navigation-drawer
			v-if="requiresAuth"
			app
			temporary
			elevation="2"
			location="right"
			v-model="useBaseStore().showSecondaryDrawer"
			:width="useBaseStore().secondaryDrawerWidth"
		>
			<div class="h-100">
				<div id="secondary-drawer" class="h-100"></div>
			</div>
		</v-navigation-drawer>

		<v-navigation-drawer
			v-if="requiresAuth"
			app
			temporary
			location="bottom"
			v-model="useBaseStore().showBottomDrawer"
			width="500"
			style="overflow: visible"
		>
			<div style="overflow: visible" class="h-100">
				<div style="overflow: visible" id="bottom-drawer"></div>
			</div>
		</v-navigation-drawer>

		<navigation-wrapper v-if="store.isAuthenticated && requiresAuth" />

		<Header />

		<v-container fluid class="page-wrapper h-100" v-if="store.isAuthenticated">
			<v-main class="h-100" style="--v-layout-top: 45px">
				<div
					:class="!store.appFullWidth ? 'maxWidth' : ''"
					class="h-100 d-flex flex-column"
				>
					<router-view />
				</div>
			</v-main>
		</v-container>

		<v-container fluid class="pb-0 pt-0 pl-0 pr-0" v-else>
			<router-view />
		</v-container>

		<v-snackbar
			v-model="showSnackbar"
			:timeout="store.toaster?.hideDelay"
			:color="store.toaster?.state"
			variant="tonal"
		>
			{{ store.toaster?.translatedMessage }}

			<template v-slot:actions>
				<v-btn color="blue" variant="text" @click="store.toaster = null">
					Close
				</v-btn>
			</template>
		</v-snackbar>
		<reload-prompt />
	</v-app>
</template>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap");
.overflow-ellipsis {
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}
body.dashboard-print-mode {
	background: white;
}
.maxWidth {
	max-width: 1200px;
	margin: 0 auto;
}
.router-link-primary {
	color: rgb(var(--v-theme-primary));
	text-decoration: underline;
}

.router-link-primary:visited {
	color: rgb(var(--v-theme-primary));
}
.v-btn.v-btn--disabled .v-btn__overlay {
	background-color: rgb(240, 243, 247) !important;
	color: rgb(83, 90, 102) !important;
}
body {
	background: rgb(var(--v-theme-background));
}
</style>
